import React from 'react';
import bootbox from 'bootbox';
import { toLonLat } from 'ol/proj';
import Dialog from '../../toolkit/dialog';
import Content from '../dashboard/Content';
import Logger from '../../toolkit/logger/Logger';
import errorDialog from '../../utils/error-dialog';
import MapSelectMarker from '../widgets/map/MapSelectMarker';
import templateService from '../../services/template-service';
import { round } from '../../utils/easy';
import { Map } from '../../utils/openlayer/map';
import { TEHRAN_COORDINATES } from '../../utils/points';
import { TextChangeEvent } from '../widgets/text-field/TextField';
import { Card, ClockPart, RangeSlider, Select, SelectSearch, SubmitButton, TextField } from '../widgets';
import { CalendarType, SensorTemplateState } from '../interfaces';
import timeUtils from '../../utils/time-utils';

const { Option } = Select;
const timezoneList = timeUtils.getSupportedTimezone();

export interface EditTemplateProps {
  match: {
    params: { templateId: string }
  }
}

const init: SensorTemplateState = {
  _id: 'شناسه الگو',
  name: '',
  description: '',
  min1: 0,
  max1: 0,
  minPhone: 0,
  maxPhone: 0,
  calibrate: 0,
  savePeriod: '00:01:00',
  alarmPeriod: '00:01:00',
  alarmActive: 0,
  location: {
    lat: null,
    lng: null
  },
  timeZone: null,
  calendarType: null
};

const RANGE_MAX = 200;
const RANGE_MIN = -80;

export default class EditTemplate extends React.Component<EditTemplateProps, SensorTemplateState> {

  state = init;

  map: Map = null;
  dialog: Dialog = null;
  options = [
    { value: 'Unknown', name: 'Unknown', disabled: true },
    { value: 'GPS', name: 'GPS' },
    { value: 'SHT11', name: 'SHT11' },
    { value: 'PT100', name: 'PT100' },
    { value: 'DS18B20', name: 'DS18B20' }
  ];

  render() {
    return (
      <Content title={'ویرایش الگو / ' + this.state.name}>
        <div className="create-edit-template-component">
          {this.renderForm()}
        </div>
      </Content>
    );
  }

  public renderForm = () => {
    const {
      name, min1, max1, minPhone, maxPhone, calibrate,
      savePeriod, alarmPeriod, timeZone, calendarType, alarmActive
    } = this.state;

    return (
      <React.Fragment>
        <div className="row justify-content-center mt-3 text-center">
          <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
            <label>نام الگو</label>
            <div className="form-group">
              <TextField
                autoFocus
                text={name}
                hint="نام الگو را بنویسید"
                style={{ textAlign: 'center' }}
                onTextChange={this.handleNameChange} />
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-3 text-center">
          <div className="col-xxl-4 col-lg-5 col-md-6 col-12">
            <label>توضیحات الگو</label>
            <div className="form-group">
              <textarea
                value={this.state.description}
                className="form-control"
                onChange={this.handleDescriptionChange}></textarea>
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-xxl-2 col-lg-4 col-md-6 col-12">
            <label>Calibrate</label>
            <div className="form-group">
              <TextField
                text={calibrate.toString()}
                onTextChange={this.handleCalibrateChange} />
            </div>
          </div>
          <div className="col-xxl-2 col-lg-4 col-md-6 col-12">
            <label>ثبت هشدار و اطلاع رسانی</label>
            <Select
              onChange={this.handleAlarmChange}
              value={alarmActive}>
              <Option value={1}>فعال</Option>
              <Option value={0}>غیر فعال</Option>
            </Select>
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
            <label>Timezone</label>
            <div className="form-group">
              <SelectSearch
                maxListHeight={'250px'}
                options={timezoneList.map(z => ({ name: z, value: z }))}
                value={timeZone ?? undefined}
                onChange={this.handleTimeZoneChange} />
            </div>
          </div>
          <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
            <div className="form-group">
              <label>نوع تقویم</label>
              <Select value={calendarType} onChange={this.handleCalendarChange}>
                <Option value="J">جلالی (شمسی)</Option>
                <Option value="G">میلادی</Option>
                <Option value="H">هجری قمری</Option>
              </Select>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-xxl-2 col-lg-4 col-md-6 col-12 mx-auto">
                <button
                  style={{ margin: '1rem 0', height: '37px' }}
                  onClick={this.handleSelectLocationClicked}
                  className="ant-btn ant-btn-primary btn-select-location">
                  <i className="fal fa-map-marker-alt ml-2"></i>
                  <span>تعیین مکان سنسور</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.renderCurrentLocation()}
        <div className="row">
          <div className="col-lg-7 col-12 mx-auto">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12 flex-center flex-column">
                <span className="my-2">دوره ذخیره سازی</span>
                <div className="form-group">
                  <ClockPart time={savePeriod} onTimeChanged={this.handleSavePeriodChange} />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 flex-center flex-column">
                <span className="d-inline-flex my-2">دوره اعلام هشدار</span>
                <div className="form-group">
                  <ClockPart time={alarmPeriod} onTimeChanged={this.handleAlarmPeriodChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-6 col-lg-10 col-12 mx-auto my-5">
            <div className="row text-left ltr flex-center">
              {this.renderRangeSlider('Min', RANGE_MIN, RANGE_MAX, min1, 'min1')}
              {this.renderRangeSlider('Max', min1, RANGE_MAX, max1, 'max1')}
              {this.renderRangeSlider('MinPhone', RANGE_MIN, min1, minPhone, 'minPhone')}
              {this.renderRangeSlider('MaxPhone', max1, RANGE_MAX, maxPhone, 'maxPhone')}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 mx-auto mb-5">
            <SubmitButton
              block={true}
              text="بروزرسانی الگو"
              onClick={this.handleSubmitClick}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }

  public renderRangeSlider = (label: string, min: number, max: number, value: number, stateKey: string) => {
    const background = label.includes('Min') ? '#53BCE9' : 'rgba(212, 75, 61, 0.85)';
    return (
      <div className="col-12 text-center rtl mt-3">
        <div className="d-flex flex-row align-items-center justify-content-center rtl">
          <span className="range-input-value">
            <input
              type="number"
              value={value}
              className="text-label"
              style={{ background }}
              onChange={this.handleRangeTextChange.bind(this, stateKey)}
              onKeyDown={this.handleRangeTextKeyDown}
            />
          </span>
          <div className="d-flex w-100 ltr">
            <RangeSlider
              min={min}
              max={max}
              size="calc(100% - 20px)"
              value={value}
              orient="horizontal"
              onChange={this.handleRangeSliderChange.bind(this, stateKey)}
            />
          </div>
          <span className="text-label">{label}</span>
        </div>
      </div>
    );
  }

  public renderCurrentLocation = () => {
    const { lat, lng } = this.state.location;
    if (lat != null) {
      return (
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12 mx-auto">
            <Card>
              <div className="d-flex">
                مکان فعلی:
                <span className="ltr">{lat} N°</span>
                <span className="mx-1">و</span>
                <span className="ltr">{lng} E°</span>
                <span className="mr-auto ml-1" role="button" onClick={this.handleUnsetLocation}>
                  <i className="far fa-times text-danger"></i>
                </span>
              </div>
            </Card>
          </div>
        </div>
      );
    }
  }

  public componentDidMount = async () => {
    const { templateId } = this.props.match.params;
    const response = await templateService.findById(templateId);
    this.setState({ ...response });
  }

  private handleNameChange = (event: TextChangeEvent) => this.setState({ name: event.target.value });

  private handleDescriptionChange = (event: any) => this.setState({ description: event.target.value });

  private handleAlarmChange = (value: any) => this.setState({ alarmActive: Number(value) });

  private handleCalibrateChange = (event: TextChangeEvent) => this.setState({ calibrate: event.target.value as any });

  private handleSavePeriodChange = (_h: number, _m: number, _s: number, time: string) => this.setState({ savePeriod: time });

  private handleAlarmPeriodChange = (_h: number, _m: number, _s: number, time: string) => this.setState({ alarmPeriod: time });

  private handleTimeZoneChange = (value: string) => this.setState({ timeZone: value });

  private handleCalendarChange = (value: CalendarType) => this.setState({ calendarType: value });

  private handleSelectLocationClicked = () => {
    const { location } = this.state;
    this.dialog = new Dialog({
      rtl: true,
      onClose: () => { this.map = null },
      title: 'مکان سنسور را تعیین کنید',
      message: (
        <div>
          <div id="dialog-map" className="ol-map dialog-map">
            <MapSelectMarker onClick={this.handleMapMarkerClicked.bind(this)} />
          </div>
        </div>
      )
    });
    this.dialog.show();

    let mapCenter;
    if (location && location.lat && location.lng) {
      mapCenter = [location.lng, location.lat];
    }
    else {
      mapCenter = TEHRAN_COORDINATES;
    }

    this.map = new Map({
      id: 'dialog-map',
      zoom: 6,
      center: mapCenter
    });
  }

  private handleUnsetLocation = () => this.setState({ location: { lat: null, lng: null } });

  private handleRangeTextKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;
    const num = Number(key);
    if (key.length > 1) {
      return;
    }
    if ((key === '-') && (!Number.isNaN(num))) {
      Logger.info(`EditTemplate::RangeChange(${key}) preventDefault(` + key + ', ' + num + ')');
      event.preventDefault();
      return;
    }
  }

  private handleRangeTextChange = (stateKey: any, event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.isDefaultPrevented()) {
      return;
    }
    const text = event.target.value.trim();
    let value = Number(text);
    if (value > RANGE_MAX) {
      value = RANGE_MAX;
    }
    if (value < RANGE_MIN) {
      value = RANGE_MIN;
    }
    if (Number.isNaN(value)) {
      value = 0;
      return event.preventDefault();
    }
    this.setState({ [stateKey]: value } as any);
  }

  private handleRangeSliderChange = (key: any, _event: any, stateKey: any) => {
    this.setState({ [key]: stateKey.value } as any);
  }

  private handleSubmitClick = async () => {
    if (this.state.name.trim() === '') {
      bootbox.alert({
        message: 'نام الگو نمیتواند خالی باشد',
        centerVertical: true
      });
      return;
    }
    try {
      const id = this.props.match.params.templateId;
      const updated = await templateService.update(id, this.state);
      if (updated) {
        bootbox.alert({
          message: 'الگو با موفقیت بروزرسانی شد',
          centerVertical: true,
          callback: () => {
            window.location.href = '/dashboard/templates';
          }
        })
      }
    }
    catch (e) {
      errorDialog(e);
    }
  }

  private handleMapMarkerClicked = () => {
    if (!this.map) {
      return;
    }
    const view = this.map.getOpenLayerMap().getView();
    const center = view.getCenter();
    const [lng, lat] = toLonLat(center);
    const update = {
      location: {
        lng: round(lng, 4), lat: round(lat, 4)
      }
    };
    this.setState(update, () => {
      if (this.dialog) {
        this.dialog.close();
        this.dialog = null;
      }
    });
  }
}
